import _createForOfIteratorHelper from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module heading/headingui
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import Model from '@ckeditor/ckeditor5-ui/src/model';
import { createDropdown, addListToDropdown } from '@ckeditor/ckeditor5-ui/src/dropdown/utils';
import { getLocalizedOptions } from './utils';
import Collection from '@ckeditor/ckeditor5-utils/src/collection';
import '../theme/heading.css';
/**
 * The headings UI feature. It introduces the `headings` dropdown.
 *
 * @extends module:core/plugin~Plugin
 */

var HeadingUI = /*#__PURE__*/function (_Plugin) {
  _inherits(HeadingUI, _Plugin);

  var _super = _createSuper(HeadingUI);

  function HeadingUI() {
    _classCallCheck(this, HeadingUI);

    return _super.apply(this, arguments);
  }

  _createClass(HeadingUI, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var _this = this;

      var editor = this.editor;
      var t = editor.t;
      var options = getLocalizedOptions(editor);
      var defaultTitle = t('Choose heading');
      var dropdownTooltip = t('Heading'); // Register UI component.

      editor.ui.componentFactory.add('heading', function (locale) {
        var titles = {};
        var itemDefinitions = new Collection();
        var headingCommand = editor.commands.get('heading');
        var paragraphCommand = editor.commands.get('paragraph');
        var commands = [headingCommand];

        var _iterator = _createForOfIteratorHelper(options),
            _step;

        try {
          var _loop = function _loop() {
            var option = _step.value;
            var def = {
              type: 'button',
              model: new Model({
                label: option.title,
                class: option.class,
                withText: true
              })
            };

            if (option.model === 'paragraph') {
              def.model.bind('isOn').to(paragraphCommand, 'value');
              def.model.set('commandName', 'paragraph');
              commands.push(paragraphCommand);
            } else {
              def.model.bind('isOn').to(headingCommand, 'value', function (value) {
                return value === option.model;
              });
              def.model.set({
                commandName: 'heading',
                commandValue: option.model
              });
            } // Add the option to the collection.


            itemDefinitions.add(def);
            titles[option.model] = option.title;
          };

          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        var dropdownView = createDropdown(locale);
        addListToDropdown(dropdownView, itemDefinitions);
        dropdownView.buttonView.set({
          isOn: false,
          withText: true,
          tooltip: dropdownTooltip
        });
        dropdownView.extendTemplate({
          attributes: {
            class: ['ck-heading-dropdown']
          }
        });
        dropdownView.bind('isEnabled').toMany(commands, 'isEnabled', function () {
          for (var _len = arguments.length, areEnabled = new Array(_len), _key = 0; _key < _len; _key++) {
            areEnabled[_key] = arguments[_key];
          }

          return areEnabled.some(function (isEnabled) {
            return isEnabled;
          });
        });
        dropdownView.buttonView.bind('label').to(headingCommand, 'value', paragraphCommand, 'value', function (value, para) {
          var whichModel = value || para && 'paragraph'; // If none of the commands is active, display default title.

          return titles[whichModel] ? titles[whichModel] : defaultTitle;
        }); // Execute command when an item from the dropdown is selected.

        _this.listenTo(dropdownView, 'execute', function (evt) {
          editor.execute(evt.source.commandName, evt.source.commandValue ? {
            value: evt.source.commandValue
          } : undefined);
          editor.editing.view.focus();
        });

        return dropdownView;
      });
    }
  }]);

  return HeadingUI;
}(Plugin);

export { HeadingUI as default };